import React from "react";
import { Form } from "antd";
import CustomDatePicker from "@components/CustomDatePicker";

const ServiceMonthField = ({ disabled = false }) => {
    const manualUpdate = Form.useWatch("manual_update");

    return (
        <CustomDatePicker
            format="YYYY-MM-DD"
            disabled={disabled || manualUpdate !== true}
        />
    );
};

export default ServiceMonthField;
